import React from "react";
import "./Hero.css";
import { siteData } from "../../data/siteData";
import Heroimage from "../../assests/images/Home-Hero.jpg";

function Hero() {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center hero-row">
          {" "}
          {/* Left Content */}
          <div className="col-lg-6">
            {/* <span className="hero-badge">Doorstep Mobile Repair Service</span> */}

            <h1 className="hero-title">
              Mobile Repair At Your Doorstep In UAE
            </h1>

            <p className="hero-description">
              Fast, reliable and professional mobile repair service. Our
              technicians come to your location and repair your device on the
              spot using high-quality parts.
            </p>

            <div className="hero-buttons">
              <a
                href={`https://wa.me/${siteData.whatsapp.replace("+", "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn hero-whatsapp-btn"
              >
                WhatsApp Us
              </a>

              <a href={`tel:${siteData.phone}`} className="btn call-btn">
                Call Now
              </a>
            </div>

            <div className="hero-features">
              <div>✓ Same Day Repair</div>
              <div>✓ Genuine Parts</div>
              <div>✓ Warranty Included</div>
            </div>
          </div>
          {/* Right Image */}
          <div className="col-lg-6 text-center">
            <img
              src={Heroimage}
              alt="Mobile Repair"
              className="img-fluid hero-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
